import React from 'react'
import cx from 'classnames'

import { Button } from 'components/shared/Button/Button'

import { useContext } from 'hooks'
import { AlertHandlersContext, AlertPropsContext } from '../../context'

import { PlusCircleIcon } from 'components/shared/Icon/model'

import styles from './ActionButton.module.scss'

export const ActionButton = () => {
  const {
    buttonClassName,
    buttonColor,
    buttonLabel,
    buttonSize,
    buttonVariant,
  } = useContext(AlertPropsContext)
  const { onAction } = useContext(AlertHandlersContext)

  return (
    <Button
      className={cx(styles.button, {
        [buttonClassName]: Boolean(buttonClassName),
      })}
      color={buttonColor}
      icon={PlusCircleIcon}
      label={buttonLabel}
      size={buttonSize}
      variant={buttonVariant}
      onClick={onAction}
    />
  )
}
